import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DocumentService } from 'app/shared/services/documentService.service';
import { CaseDetails, OfferList } from '../../details-new/details-new.data'
import { CaseFunctions } from '../../details-new/caseFunctions';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { KeyValue, SubscriptionObject } from 'app/shared/models/standard.models';
import { Router } from '@angular/router';
import { OfferFromCompany, OfferOnExistingCase } from '../../shared/models/document-models';
import { OfferRejection } from '../../settings/category-setup/category-setup.component';
import { OfferApi } from 'app/shared/api/offer.api';
import { SharedDataService } from '../../shared/services/shared-data.service';
import * as api from '../../shared/api/apihandler';
import { CompanyInformation } from '../details/models';
import { TranslateService } from '@ngx-translate/core';
import { Offer } from '../details/offer';
import { Dates } from 'app/shared/utilities/shared.functions';
import { DateUtilities } from 'app/shared/utilities/dateUtilities';
import { format } from 'date-fns';

@Component({
  selector: 'app-case-documents',
  templateUrl: './case-documents.component.html',
  styleUrls: ['./case-documents.component.css']
})
export class CaseDocumentsComponent implements OnInit, OnDestroy {
  subs: SubscriptionObject = {};
  companyInfo: CompanyInformation;

  case: CaseDetails;
  caseActions = new CaseFunctions(this.http);
  offerApi = new OfferApi(this.http);
  l: OfferList[];

  statuses: KeyValue[];
  doc;
  styles;
  specialDoc: boolean = true;
  acceptReject = new AcceptOrReject();
  newDocument = new OfferOnExistingCase();
  departments: any[] = [];
  responsibles: any[] = [];
  channels: any[] | null = null;
  stages: any[] | null = null;
  modules: Array<string> = [];
  rejection = new Rejections();
  planDate: Date;
  bsConfig = DateUtilities.bsConfig;
  planTime = '08:00';
  planHours = '1';
  planMinutes = '00';
  planFitter;
  planDescription = '';
  dueTimes = Dates.dueTimes;
  durationHours = Dates.durationHours;
  durationMinutes = Dates.durationMinutes;
  companyUsers;
  acceptBtnDisabled = false;
  hasKlarPris: boolean = false;
  caseProps;
  unitData;
  clearPriceDocuments: string[] = [];
  clearPriceStep = 0;
  clearPriceBasket = [];
  clearPriceBasketInfo = new ClearPriceBasketInfo();
  forDeletion;
  isTaurus: boolean = JSON.parse(localStorage.getItem('userInfo'))?.CompanyNumber == '33848' ? true : false;

  constructor(private http: HttpClient, private router: Router, private offerService: DocumentService, private shared: SharedDataService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.subs['currentCase'] = this.offerService.currentCase().subscribe({
      next: (data: CaseDetails) => {
        this.l = data.offerList;
        this.case = data;
        this.getCaseProperties();
      }
    });
    this.subs['offerStatuses'] = this.offerService.offerStatuses().subscribe({
      next: (data: KeyValue[]) => { this.statuses = data; }
    });
    this.subs['departments'] = this.shared.departments().subscribe({
      next: (data) => { this.departments = data; }
    });
    this.subs['responsibles'] = this.shared.responsibles().subscribe({
      next: (data) => { this.responsibles = data; }
    });
    this.subs['companyUsers'] = this.shared.companyUsers().subscribe(data => {
      this.companyUsers = data;
      let a = localStorage.getItem('bearer');
      this.planFitter = this.companyUsers.find(x => x.userId == a).userId;
    });
    this.subs['companyInformation'] = this.shared.companyInformation().subscribe(data => {
      this.companyInfo = data;
      this.loadAll();
    });
  }

  loadAll() {
    if (!!JSON.parse(localStorage.getItem('guards'))) {
      this.modules = JSON.parse(localStorage.getItem('guards')).map(x => x.name);
    }
    this.getChannels();
    this.getStages();
    this.getOfferRejections();
    this.checkIfClearPrice();
  }

  ngOnDestroy(): void {
    for (let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  getChannels() {
    this.caseActions.getCaseChannels().subscribe({
      next: (data: any[]) => { this.channels = data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1); }
    });
  }

  getStages() {
    this.caseActions.getCaseStages().subscribe({
      next: (data: any[]) => { this.stages = data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1); }
    });
  }

  tester() {
    console.log(this.forDeletion)
  }

  getCaseProperties() {
    this.caseActions.getCaseProperties(this.case.caseId).subscribe({
      next: (data: any[]) => {
        if (!!data) {
          this.caseProps = {
            costPrice: +data.find(x => x.propertyId == '8aaa8ef4-1538-4681-a978-b04e505445ff')?.value ?? null,
            salesPrice: +data.find(x => x.propertyId == '7d5f4c8d-61a1-4218-b63a-3472af4b1e49')?.value ?? null,
            serviceType: data.find(x => x.propertyId == '1d410800-22c6-40e1-95af-91c67cbb189c')?.value ?? null,
            installationTimeInMinutes: +data.find(x => x.propertyId == '68671d14-c4ec-420a-95c1-efda8a4768db')?.value ?? null,
            packageId: data.find(x => x.propertyId == '2e817829-f3e8-4e91-ba99-8c36136eafee')?.value ?? null,
            packageNumber: data.find(x => x.propertyId == '9b768bed-cb95-44b9-800d-363743d55f40')?.value ?? null
          }
          if (!!data.find(x => x.propertyId == '2e817829-f3e8-4e91-ba99-8c36136eafee')) this.getPackageData(data.find(x => x.propertyId == '2e817829-f3e8-4e91-ba99-8c36136eafee').value);
        }
      }
    })
  }

  getPackageData(unitId) {
    this.caseActions.getUnit(unitId).subscribe({
      next: (data) => this.unitData = data
    })
  }

  checkIfClearPrice() {
    this.caseActions.hasClearPrice().subscribe({
      next: (data: boolean) => {
        this.hasKlarPris = data;
        if (!!data) {

        }
      }
    });
  }

  getOrderHistory() {
    this.caseActions.getOrderHistory(this.case.caseId).subscribe({
      next: (data) => console.log('Order history', data)
    })
  }

  get offers() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '91946653-6667-4f47-97b5-044e5e6b26dd') : [];
  }

  get agreementNotes() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '9865a758-33e6-41c8-bc04-d1b3ac64f72c') : [];
  }

  get productDocs() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '91946653-6667-4f47-97b5-044e5e6b26dd' || x.offerTypeId == '9865a758-33e6-41c8-bc04-d1b3ac64f72c') : [];
  }

  get contracts() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '0fd35664-fe7f-418b-b82d-67e2d2e1189f') : [];
  }

  get housingAssesments() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == 'ae642e3d-a1e7-449c-a893-048f7923fb55') : [];
  }

  get subcontractorOffers() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '5b4c0821-af7e-48e9-b651-29c4379b4b46') : [];;
  }

  get serviceContracts() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '039ee8f9-ad58-4568-bde7-cecb88f869c9') : [];
  }

  get variationOrders() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '9865a758-33e6-41c8-bc04-d1b3ac64f72c') : [];
  }

  get maintenanceBudget() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '2df3ade1-f984-4cb2-855c-d46815f4a444') : [];
  }

  get supervisoryNotes() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == 'ebdcc11a-59df-4d01-81e4-6b0cd775c8eb') : [];
  }

  get energyReports() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == '01d076cc-5cf6-4de4-ae22-2a3a931983d3') : [];
  }

  get moveInOut() {
    return !!this.l ? this.l.filter(x => x.offerTypeId == 'fdcb8af2-ec3c-4cf1-840e-79900154c64b') : [];
  }

  trackById(x) {
    return !!x.offerId ? !!x.offerId : null;
  }

  getTotal(list: OfferList[]) {
    let totals = list.reduce((total, current) => total + (!!current.totalPrice ? current.totalPrice : 0), 0);
    return this.formatCurrency(totals)
  }

  formatCurrency(n: number) {
    return Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(n);
  }

  route(o, ev) {
    if (!['svg', 'button', 'div', 'path', 'ul', 'li'].includes(ev.target.tagName.toLowerCase())) {
      this.router.navigate(['/CreateDocument/' + this.case.caseId], { queryParams: { o: o.offerId, t: o.offerTypeId } });
    } else {
      let v = document.getElementById('actionsMenu-' + o.offerId);
      v.style.visibility = v.style.visibility == 'visible' ? 'hidden' : 'visible';
      this.acceptBtnDisabled = false;
    }
  }

  resetNewDocument() {
    this.newDocument = new OfferOnExistingCase();
    this.newDocument.responsibleId = localStorage.getItem('bearer');
    this.newDocument.caseId = this.case.caseId;
  }

  setOfferType() {

  }

  addNewDocumentToCase() {
    switch (this.newDocument.offerTypeId) {
      case 'fdcb8af2-ec3c-4cf1-840e-79900154c64b':
        this.newDocument.title = this.translate.instant('Standard.MoveInOutReport');
        break;
      case 'ae642e3d-a1e7-449c-a893-048f7923fb55':
        this.newDocument.title = this.translate.instant('Standard.CooperativeHousingAssessment');
        break;
      case '2df3ade1-f984-4cb2-855c-d46815f4a444':
        this.newDocument.title = this.translate.instant('Standard.MaintenanceBudget');
        break;
      case 'ebdcc11a-59df-4d01-81e4-6b0cd775c8eb':
        this.newDocument.title = this.translate.instant('Standard.SupervisoryNotes');
        break;
      case '01d076cc-5cf6-4de4-ae22-2a3a931983d3':
        this.newDocument.title = this.translate.instant('Standard.EnergyReport');
        break;
      case '039ee8f9-ad58-4568-bde7-cecb88f869c9':
        this.newDocument.title = this.translate.instant('Asset.ServiceContract');
        break;
      default:
        break;
    }
    //return
    this.offerApi.offerOnExistingCase(this.newDocument).subscribe({
      next: (data) => {
        this.newDocument.responsibleId = localStorage.getItem('bearer');
        this.router.navigate(['/', 'CreateDocument', this.case.caseId], { queryParams: { o: data, t: this.newDocument.offerTypeId } });
      }
    });
  }

  changeType() {
    if (['fdcb8af2-ec3c-4cf1-840e-79900154c64b', '2df3ade1-f984-4cb2-855c-d46815f4a444', '01d076cc-5cf6-4de4-ae22-2a3a931983d3', '039ee8f9-ad58-4568-bde7-cecb88f869c9', 'ae642e3d-a1e7-449c-a893-048f7923fb55', 'ebdcc11a-59df-4d01-81e4-6b0cd775c8eb'].includes(this.newDocument.offerTypeId)) {
      console.log('sepcial')
      this.specialDoc = true;
    } else {
      this.specialDoc = false;
    }
  }

  documentActions(offer: any) {
    this.acceptReject.step = 'accept';
    this.acceptReject.offer = offer;
    document.getElementById('actionsMenu-' + offer.offerId).style.visibility = 'hidden !important';
  }

  async newOfferStatus(offer: any, newStatus: string | null) {
    let message = '';
    let activityType = '36fc4a45-1375-4046-95ac-1ebeeb143525'
    if (newStatus == '8bfc347c-40c4-42ca-93fc-f4d651c0a109') { // New to Pipeline
      message = await this.translate.instant('Activity.HasChangedOffer') + ' ' + offer.offerNumber + ' ' + this.translate.instant('Activity.StatusTo') + ' ' + this.translate.instant('Offers.Pipeline');
      activityType = 'e9970b72-c6a4-4eaa-9647-c3587037a88c';
    } else if (newStatus == 'f833a8c3-2944-4a3d-a9b3-8faa01156485') { // Pipeline to New
      message = await this.translate.instant('Activity.HasChangedOffer') + ' ' + offer.offerNumber + ' ' + this.translate.instant('Activity.StatusTo') + ' ' + this.translate.instant('Offers.New');
      activityType = '36fc4a45-1375-4046-95ac-1ebeeb143525';
    } else if (newStatus == '728eade9-0a48-4b0e-8c8f-20c585c032c0') { // X to Deselected
      message = await this.translate.instant('Activity.HasChangedOffer') + ' ' + offer.offerNumber + ' ' + this.translate.instant('Activity.StatusTo') + ' ' + this.translate.instant('Offers.Deselected');
      activityType = 'df4dccd9-1b9c-4a72-91b9-944f9e34b56f';
    }

    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    this.http.patch(api.jubloApi + 'api/Website/Offer/ChangeStatus/' + offer.offerId, { "caseOfferStatusId": newStatus }, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.acceptReject.step = 'start';
        this.offers.find(x => x.offerId == offer.offerId).statusId = newStatus;
        this.updateActivity(activityType, message);
      }
    });
  }

  getOfferRejections() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get<Array<OfferRejection>>(api.jubloApi + 'api/Website/Offer/GetOfferRejectionAnswers', { headers }).subscribe({
      next: (data) => {
        this.rejection.reasonList = data;
      },
      error: err => console.error(err)
    });
  }

  statusByGuid(id) {
    if (!!id) {
      switch (id.toLowerCase()) {
        case ('bee21fe3-503e-4a8b-8ac4-030929c87741'): {
          return { text: 'Offers.AwaitingAccept', color: 'badge-info' }
        }
        case ('e65f9d9e-34b2-4423-8ad4-7228db8814b4'): {
          return { text: 'Offers.Rejected', color: 'badge-danger' }
        }
        case ('a1a453b8-6ae7-453d-bfdb-867ace78654e'): {
          return { text: 'Offers.Accepted', color: 'badge-success' }
        }
        case ('f833a8c3-2944-4a3d-a9b3-8faa01156485'): {
          return { text: 'Offers.New', color: 'badge-warning' }
        }
        case ('dc604f52-769c-4568-88f5-b77ff41ad95e'):
        case ('e958c326-863b-4545-bf13-bb6df821f2fd'): {
          return { text: 'Offers.AwaitingReply', color: 'badge-info' }
        }
        case ('8bfc347c-40c4-42ca-93fc-f4d651c0a109'): {
          return { text: 'Offers.Pipeline', color: 'badge-light' }
        }
        default: {
          return { text: 'Offers.Other', color: 'badge-warning' }
        }
      }
    } else {
      return { text: 'Offers.New', color: 'badge-warning' };
    }
  }

  setPlanDate(event: Date) {
    this.planDate = event;
  }

  async rejectOffer() {
    let reason = this.rejection.reasonList.find(x => x.id == this.rejection.chosen).text;
    let m = await this.translate.instant('Activity.OfferRejected') + ' ' + this.acceptReject.offer.offerNumber + '. ' + this.translate.instant('Standard.Reason') + ': ' + reason + '. ' + this.translate.instant('Standard.ReasonText') + ': ' + this.rejection.message;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer'), 'Content-Type': 'application/json' });
    this.http.patch(api.jubloApi + 'api/Website/Offer/ChangeStatus/' + this.acceptReject.offer.offerId, { "caseOfferStatusId": 'e65f9d9e-34b2-4423-8ad4-7228db8814b4' }, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.acceptReject.step = 'start';
        this.offers.find(x => x.offerId == this.acceptReject.offer.offerId).statusId = 'e65f9d9e-34b2-4423-8ad4-7228db8814b4';
        this.updateActivity('63d4d65b-ecb4-4928-b8a1-b91d80e01ec7', m);
        document.getElementById('changeStatusCloseBtn').click();
      }
    });
  }

  acceptOffer() {
    this.acceptBtnDisabled = true;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (!!this.planDate) {
      let duration = +this.planHours * 60 + +this.planMinutes;
      const timeParts = this.planTime.split(':').map(part => parseInt(part, 10));
      const hours = timeParts[0];
      const minutes = timeParts[1];
      const mergedDateTime = new Date(this.planDate.getTime());
      mergedDateTime.setHours(hours, minutes, 0, 0);
      let startTime = mergedDateTime.toISOString();;
      let end = new Date(startTime).setMinutes(new Date(startTime).getMinutes() + duration);
      let endTime = new Date(end).toISOString();
      this.http.post(api.jubloApi + 'api/Website/OfferRequest/CreateTask/' + this.case.caseId,
        {
          "customerId": this.acceptReject.offer.customerId,
          "fitterId": this.planFitter,
          "startTime": startTime,
          "endTime": endTime
        },
        { headers }).subscribe({
          error: err => console.error(err),
          complete: () => {
            this.acceptReject.step = 'start';
          }
        });
    } else if (!!this.companyInfo && this.companyInfo.vat == '12147376') {
      this.updateStatus('6991f0ea-bdb5-4e30-868f-46c43d712e9b')
    }
    let statusKey = 'a1a453b8-6ae7-453d-bfdb-867ace78654e';
    this.http.patch(api.jubloApi + 'api/Website/Offer/ChangeStatus/' + this.acceptReject.offer.offerId, { "caseOfferStatusId": statusKey }, { headers }).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.offers.find(x => x.offerId == this.acceptReject.offer.offerId).statusId = statusKey;
        let m = this.translate.instant('Activity.OfferAccepted') + ' ' + this.acceptReject.offer.offerNumber + '.';
        this.updateActivity('20c0c266-3a6c-4e38-882c-3fc2e88034bf', m);
        document.getElementById('changeStatusCloseBtn').click();
      }
    });
  }

  updateStatus(statusId) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.patch(api.jubloApi + 'api/Website/Case/' + this.case.caseId + '/Set/Status/' + statusId, {}, { headers }).subscribe({
      error: err => console.error(err)
    });
  }

  updateActivity(historyType: string, text: string) {
    this.shared.setCaseActivity(historyType, text, null, '89a41c6c-6a83-4978-90bb-ca7ec2d19a26', this.case.caseId).subscribe({
      error: err => console.error(err),
      complete: () => { }
    });
  }

  autoSetDeliveryToClearPriceBasketInfo() {
    //this.clearPriceBasketInfo = new ClearPriceBasketInfo();
    this.clearPriceBasketInfo.orderNumber = this.case.caseNumber != null ? this.case.caseNumber : this.case.externalId != null ? this.case.externalId : '';
    let d = this.case.deliveryAddress;
    let c = this.case.customer;
    if (d.id != null) {
      this.clearPriceBasketInfo.name = d.name;
      this.clearPriceBasketInfo.address = d.address;
      this.clearPriceBasketInfo.zipCode = d.zipCode;
      this.clearPriceBasketInfo.city = d.city;
    }
    else {
      this.clearPriceBasketInfo.name = c.name;
      this.clearPriceBasketInfo.address = c.address;
      this.clearPriceBasketInfo.zipCode = c.zipCode;
      this.clearPriceBasketInfo.city = c.city;
    }
  }

  docToClearPrice(id) {
    if (this.clearPriceDocuments.includes(id)) {
      this.clearPriceDocuments = this.clearPriceDocuments.filter(x => x != id);
    } else {
      this.clearPriceDocuments.push(id);
    }
  }

  async addToClearPriceBasket(id: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (this.clearPriceBasket.includes(id)) {
        this.clearPriceBasket.splice(this.clearPriceBasket.indexOf(id), 1);
        this.clearPriceBasketInfo.products = this.clearPriceBasketInfo.products.filter(x => x.offerId != id);
        resolve();
      } else {
        this.clearPriceBasket.push(id);
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.http.get<Offer>(api.jubloApi + 'api/Website/Offer/' + id, { headers }).subscribe({
          next: (data) => {
            let a = data.productLines.filter(y => !!y.wholeSaler && +y.wholeSaler < 99).map(x => {
              return {
                offerId: id,
                productId: x.productNumber,
                wholesaler: x.wholeSaler,
                quantity: x.quantity.toString()
              }
            });
            this.clearPriceBasketInfo.products = this.clearPriceBasketInfo.products.concat(a);
            resolve(); // Markerer, at GET-anmodningen er fuldført
          },
          error: err => {
            console.error(err);
            reject(err); // Markerer, at GET-anmodningen er mislykket
          }
        });
      }
    });
  }

  async addToBasket() {
    let fetchPromises: Promise<void>[] = [];

    for (let id of this.clearPriceDocuments) {
      let fetchPromise = this.addToClearPriceBasket(id);
      fetchPromises.push(fetchPromise);
    }

    try {
      // Vent på, at alle GET-anmodninger er færdige
      await Promise.all(fetchPromises);

      const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('bearer') });
      this.http.post(api.jubloApi + 'api/Website/OfferProductSearch/ClearPriceBasket', this.clearPriceBasketInfo, { headers, responseType: 'text' as 'json' }).subscribe({
        next: (val: any) => {
          let encodedString = encodeURIComponent(val).toString();
          this.router.navigate(['/Shop'], { queryParams: { basket: encodedString } });
        },
        error: err => console.error(err)
      });
    } catch (error) {
      console.error('Fejl under hentning af data:', error);
    }
  }

  deleteDocument() {
    this.offerApi.deleteDocument(this.forDeletion.offerId).subscribe({
      complete: () => {
        this.l = this.l.filter(x => x.offerId != this.forDeletion.offerId)
      }
    })
  }

  sentAtDate(sentAt: string) {
    return format(new Date(sentAt), 'dd-MM-yyyy');
  }
}

export class AcceptOrReject {
  offer: any;
  step: 'start' | 'reject' | 'accept' = 'start';
}

export class Rejections {
  public translationList = ['Standard.NoneChosen', 'Offers.RejectReason.Price', 'Offers.RejectReason.NotReady', 'Offers.RejectReason.Other', 'Offers.RejectReason.NoAnswer'];
  public reasonList = [];
  public chosen: string = null;
  public message = '';
  public messageHeader = '';
  public reasonText = '';
}

class ClearPriceBasketInfo {
  products: Array<any> = [];
  name: string = '';
  address: string = '';
  zipCode: string = '';
  city: string = '';
  orderNumber: string = '';
}